"use strict";

import angular from "angular";

class LoaderDialogCtrl {
    constructor() {}
}

angular.module("nucont.shared").controller("LoaderDialogCtrl", [LoaderDialogCtrl]);
